import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/notification';
import { selectors, DEFAULT_STATE } from '../reducers/notification';
import api from '../apis/notification';

const sagas = helper.createSagas(
    'notification',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
